import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { AbstractBaseComponent } from 'src/app/model/AbstractBaseComponent';
import { SharedService } from 'src/app/shared/shared.service';
import { InstructorOrTutorDTO } from '../../../model/newModel';
import { InstructorService } from './instructor.service';

@Component({
  selector: 'app-instructor',
  templateUrl: './instructor.component.html',
  styleUrls: ['./instructor.component.css'],
})
export class InstructorComponent
  extends AbstractBaseComponent
  implements AfterViewInit, OnInit, OnDestroy {
  instructor: InstructorOrTutorDTO;
  emailForm: FormGroup;
  submitted = false;

  constructor(
    private spinner: NgxSpinnerService,
    public ngxSmartModalService: NgxSmartModalService,
    private instructorService: InstructorService,
    private route: ActivatedRoute,
    private sharedService: SharedService,
    private formBuilder: FormBuilder
  ) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.route.queryParams.subscribe((params) => {
      this.spinner.show();
      this.instructorService.getInstructor(params.idInstructor).subscribe(
        (result) => {
          this.spinner.hide();
          this.instructor = result;
        },
        (error) => {
          this.spinner.hide();
          console.log('Errore getInstructor');
        }
      );
    });

    this.emailForm = this.formBuilder.group({
      oggetto: ['', Validators.required],
      messaggio: ['', Validators.required],
    });
  }

  get f() {
    return this.emailForm.controls;
  }

  onSubmit() {
    this.submitted = true;
    this.spinner.show();
    // stop here if form is invalid
    this.spinner.hide();
    const text = 'Funzionalità non rilasciata!';
    this.sharedService.openWarningModal(text);

    // if (this.emailForm.invalid) {
    //     this.spinner.hide();
    //     const text = 'Form non valido!';this.sharedService.openWarningModal(text);
    // } else {
    //   const sendEmail  = new SendEmailCommand();
    //   sendEmail.emailInstructor = this.instructor.email;
    //   sendEmail.emailStudente = this.studente.email;
    //   sendEmail.nomeStudente = this.studente.nome + ' ' + this.studente.cognome;
    //   sendEmail.oggetto = this.f.oggetto.value;
    //   sendEmail.messaggio = this.f.messaggio.value;

    //   this.sharedService.sendEmail(sendEmail).subscribe(result => {
    //     this.spinner.hide();this.sharedService.openOkModal();
    //     this.modalSubscribe = this.ngxSmartModalService.getModal('okModal').onClose.subscribe((modal: NgxSmartModalComponent) => {
    //       window.location.reload();
    //     });
    //   }, error => {
    //     this.spinner.hide();
    //     this.sharedService.openKoModal();
    //   });
    // }
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
  }
}
